import {
  buildDefaultFormState,
  mapConfigToFormState as mapConfigToFormStateFromFields,
  mapFormStateToPayload as mapFieldsToPayload,
} from "features/shared/lib/technical-config-tab/formStateBuilders";

import type { WindowCatalogItem, WindowTechnology } from "../model/types";

import {
  getActiveFieldDefinitions,
  getTabFieldDefinitions,
  type WindowConfigFormState,
} from "./windowConfigFieldDefinitions";
import {
  findWindowCatalogItemById,
  isShadingLocationSelected,
  normalizeShadingLocationForApi,
  normalizeShadingLocationToForm,
  normalizeShadingSystemTypeToForm,
} from "./windowConfigOptions";

export const defaultWindowConfigFormState = (): WindowConfigFormState => ({
  ...buildDefaultFormState(getActiveFieldDefinitions()),
});

const mapShadingLocationToFormState = (rawLocation: unknown): string =>
  normalizeShadingLocationToForm(rawLocation as null | string | undefined);

export const mapTechnologyToFormState = (
  technology?: null | WindowTechnology,
  catalog: WindowCatalogItem[] = []
): WindowConfigFormState => {
  const base = mapConfigToFormStateFromFields<WindowConfigFormState, WindowTechnology>({
    config: technology ?? undefined,
    fields: getActiveFieldDefinitions(),
    getRawValue: (config, field) => config?.[field.key],
  });

  if (!technology) return base;

  const catalogItem = findWindowCatalogItemById(catalog, technology.windowTypeDbId);

  return {
    ...base,
    frameType: String(technology.frameType ?? catalogItem?.frameTypeName ?? base.frameType),
    shadingLocation: mapShadingLocationToFormState(technology.shadingLocation),
    shadingSystemType: normalizeShadingSystemTypeToForm(base.shadingSystemType),

    // TODO: Check if this line is needed
    // windowTypeName: String(catalogItem?.windowTypeName ?? base.windowTypeName),
  };
};

export const mapFormStateToPayload = (formState: WindowConfigFormState) => {
  const payload = mapFieldsToPayload(formState, getTabFieldDefinitions());

  return {
    ...payload,
    shadingLocation: isShadingLocationSelected(formState.shadingLocation)
      ? normalizeShadingLocationForApi(formState.shadingLocation)
      : undefined,
  };
};
